export const roleApply = {
  filterInfo: {
    filterList: [
      {
        label: '角色名称',
        type: 'input',
        value: 'roleName',
      },
      {
        label: '角色描述',
        type: 'input',
        value: 'remark',
      },
      {
        label: '审核状态',
        type: 'select',
        value: 'roleStatus',
        list: 'roleStatusList',
      },
    ],
    count: 12,
    data: {
      roleStatus: null,
    },
    btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
  },
  listTypeInfo: {
    roleStatusList: [
      { name: '已拥有', id: 1 },
      { name: '申请中', id: 2 },
      { name: '未拥有', id: 3 },
    ],
  },
  tableLabel: [
    {
      label: '序号',
      param: 'index',
      align: 'center',
      fixed: 'left',
      slot: 'indexSlot',
      width: '80',
    },
    { label: '角色名称', param: 'roleName', align: 'center', width: '200' },
    {
      label: '角色描述',
      param: 'remark',
      align: 'center',
      tooltip: true,
    },
    {
      label: '角色状态',
      param: 'roleStatus',
      align: 'center',
      slot: 'roleStatusSlot',
      width: '150',
    },
    {
      label: '操作',
      param: 'options',
      align: 'center',
      slot: 'optionsSlot',
      width: '200',
    },
  ],
  filterInfoR: {
    filterList: [
      {
        label: '角色名称',
        type: 'input',
        value: 'roleName',
      },
      // {
      //   label: '角色描述',
      //   type: 'input',
      //   value: 'remark',
      // },
      {
        label: '审核状态',
        type: 'select',
        value: 'status',
        list: 'statusList',
      },
    ],
    count: 12,
    data: {
      status: null,
    },
    btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
  },
  listTypeInfoR: {
    statusList: [
      { name: '待审批', id: 1 },
      { name: '审批通过', id: 2 },
      { name: '审批拒绝', id: 3 },
    ],
  },
  tableLabelR: [
    {
      label: '序号',
      param: 'index',
      align: 'center',
      fixed: 'left',
      slot: 'indexSlot',
      width: '80',
    },
    { label: '申请时间', param: 'createTime', align: 'center', width: '200' },
    {
      label: '角色名称',
      param: 'roleList',
      align: 'center',
      width: '200',
      slot: 'roleListRoleName',
    },
    {
      label: '申请原因',
      param: 'reason',
      align: 'center',
      tooltip: true,
      slot: 'reasonSlot',
    },
    {
      label: '审核状态',
      param: 'status',
      align: 'center',
      slot: 'statuseSlot',
      width: '150',
    },
  ],
  filterInfoCR: {
    filterList: [
      {
        label: '申请人',
        type: 'input',
        value: 'createByName',
      },
      {
        label: '申请账号',
        type: 'input',
        value: 'memberName',
      },
      {
        label: '包含角色',
        type: 'autocomplete',
        value: 'roleList',
      },
      {
        label: '审核人账号',
        type: 'input',
        value: 'operationMemberName',
      },
    ],
    count: 12,
    data: {},
    btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
  },
  tableLabelCR: [
    {
      label: '序号',
      param: 'index',
      align: 'center',
      fixed: 'left',
      slot: 'indexSlot',
      width: '80',
    },
    { label: '申请人', param: 'createByName', align: 'center', width: '200' },
    { label: '申请账号', param: 'memberName', align: 'center', width: '200' },
    {
      label: '申请角色',
      param: 'roleList',
      align: 'center',
      width: '200',
      slot: 'roleList',
    },
    { label: '申请原因', param: 'reason', align: 'center', tooltip: true },
    {
      label: '审核人账号',
      param: 'operationMemberName',
      align: 'center',
    },
    { label: '申请时间', param: 'createTime', align: 'center', width: '200' },
    {
      label: '审核时间',
      param: 'operationTime',
      align: 'center',
      width: '200',
    },
    {
      label: '审核结果',
      param: 'status',
      align: 'center',
      slot: 'statusSlot',
      width: '150',
    },
  ],
  filterInfoC: {
    filterList: [
      {
        label: '申请人',
        type: 'input',
        value: 'createByName',
      },
      {
        label: '申请账号',
        type: 'input',
        value: 'memberName',
      },
      {
        label: '包含角色',
        type: 'autocomplete',
        value: 'roleList',
      },
    ],
    count: 12,
    data: {},
    btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
  },
  listTypeInfoC: {},
  tableLabelC: [
    {
      label: '序号',
      param: 'index',
      align: 'center',
      fixed: 'left',
      slot: 'indexSlot',
      width: '80',
    },
    { label: '申请时间', param: 'createTime', align: 'center', width: '200' },
    { label: '申请人', param: 'createByName', align: 'center', width: '200' },
    { label: '申请账号', param: 'memberName', align: 'center', width: '200' },
    {
      label: '申请角色',
      param: 'roleList',
      align: 'center',
      width: '200',
      slot: 'roleList',
    },
    { label: '申请原因', param: 'reason', align: 'center', tooltip: true },
    {
      label: '操作',
      param: 'options',
      align: 'center',
      slot: 'optionsSlot',
      width: '200',
    },
  ],
};

export const defaults = {};
